import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Button, IconButton } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';

const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

export default function Header(props) {

    const [loggedIn, setLoggedIn] = useState(true);

    // const [position, setPosition] = useState("static");

    const handleLogout = () => {
        localStorage.clear();
        if(props.name != undefined){
            window.location = '/'+props.name;
        }else{
            window.location = '/';
        }
    };

    useEffect(() => {
        if(props.isLoggedIn == false){
            setLoggedIn(props.isLoggedIn);
        }
        else{
            setLoggedIn(true);
        }
        if(props.position == "fixed"){
            // setPosition("fixed")
        }

    }, [])

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar color='' sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    {props.onMenu ? (
                        <IconButton aria-label="Abrir menú" onClick={props.onMenu} sx={{ mr: 0.5, color: "#161E55" }}>
                            <MenuIcon />
                        </IconButton>
                    ) : null}
                    <Box component="div" sx={{ flexGrow: 1, minWidth: 0 }}>
                        <img
                            src={`https://user-images.githubusercontent.com/43441715/151676110-239f759b-7693-459c-a7f0-3a409972fd1e.png`}
                            loading="lazy"
                            alt="Prami"
                            height={props.compact ? 36 : 60}
                            style={{ marginTop: props.compact ? 8 : 15, marginBottom: props.compact ? 8 : 15, marginLeft: props.compact ? 0 : 10, maxWidth: props.compact ? 120 : "none", width: "auto" }}
                        />
                    </Box>
                    {loggedIn ? <Box sx={{ flexGrow: 0 }}>
                    <Button variant="text" aria-label="Cerrar sesión" onClick={handleLogout} sx={props.compact ? { minWidth: 44, px: 1 } : undefined}>
                        {props.compact ? null : "Cerrar sesión"}
                        <LogoutIcon />
                    </Button>
                    </Box> : null}
                </Toolbar>
            </AppBar>
        
        </Box>
    );
}